// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sceneConfigWrap {
  width: 100%;
  background-color: #444444;
}
.sceneConfigWrap .container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.sceneConfigWrap .container .titleWrap {
  position: absolute;
  left: 50%;
  z-index: 21;
}
.sceneConfigWrap .container .commentWrapper {
  float: right;
  margin-top: 16px;
  margin-right: 12px;
  position: relative;
  z-index: 12;
  width: 88px;
  height: 32px;
  background-color: #f3f4f5;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sceneConfigWrap .container .commentWrapper span {
  font-size: 14px;
  font-weight: 500;
  color: black;
}
.sceneConfigWrap .container .sliderWrapper {
  top: 16px;
  right: 21px;
  width: 160px;
  height: 40px;
  display: inline-block;
  position: absolute;
  font-size: 12px;
  z-index: 10;
}
.sceneConfigWrap .container .sliderWrapper .customSlider {
  left: 6px;
}
.sceneConfigWrap .container .sliderWrapper .sliderLabel {
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
}
.sceneConfigWrap .container .sliderWrapper .upper {
  float: left;
  margin-left: 5px;
  color: #8a8f98;
}
.sceneConfigWrap .container .sliderWrapper .lower {
  float: right;
  margin-right: 5px;
  color: #8a8f98;
}
.sliderPopover .ant-popover-content {
  top: 30px;
  right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/index.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EAEA,yBAAA;AAAF;AAHA;EAKI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AATA;EAWM,kBAAA;EACA,SAAA;EAEA,WAAA;AAAN;AAdA;EAkBM,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADN;AA7BA;EAkCQ,eAAA;EACA,gBAAA;EACA,YAAA;AAFR;AAlCA;EA0CM,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AALN;AA5CA;EAoDQ,SAAA;AALR;AA/CA;EA+FQ,gBAAA;EACA,kBAAA;EACA,eAAA;AA7CR;AApDA;EAqGQ,WAAA;EACA,gBAAA;EACA,cAAA;AA9CR;AAzDA;EA2GQ,YAAA;EACA,iBAAA;EACA,cAAA;AA/CR;AAqDA;EAEI,SAAA;EACA,WAAA;AApDJ","sourcesContent":[".sceneConfigWrap {\n  width: 100%;\n  //background-image: linear-gradient(to right top, #7c7c7c, #828282, #878787, #8d8d8d, #939393, #9b9b9b, #a3a3a3, #ababab, #b7b7b7, #c3c3c3, #d0d0d0, #dcdcdc);\n  background-color: #444444;\n  .container {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n\n    .titleWrap {\n      position: absolute;\n      left: 50%;\n\n      z-index: 21;\n    }\n\n    .commentWrapper {\n      float: right;\n      margin-top: 16px;\n      margin-right: 12px;\n      position: relative;\n      z-index: 12;\n      width: 88px;\n      height: 32px;\n      background-color: #f3f4f5;\n      border-radius: 8px;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n\n      span {\n        font-size: 14px;\n        font-weight: 500;\n        color: black;\n      }\n    }\n\n    .sliderWrapper {\n      //top: 80px;\n      top: 16px;\n      right: 21px;\n      width: 160px;\n      height: 40px;\n      display: inline-block;\n      position: absolute;\n      font-size: 12px;\n      z-index: 10;\n\n      .customSlider {\n        left: 6px;\n      }\n\n      //.ant-slider-rail {\n      //  background-color: white;\n      //  height: 8px;\n      //  border-radius: 4px;\n      //  z-index: 12;\n      //\n      //  &::after {\n      //    content: '';\n      //    position: absolute;\n      //    top: 0px;\n      //    left: 50%;\n      //    transform: translateX(-50%);\n      //    display: block;\n      //    width: 2px;\n      //    height: 8px;\n      //    background-color: #6C6D72;\n      //  }\n      //}\n      //\n      //.ant-slider-track {\n      //  background-color: white;\n      //}\n      //\n      //.ant-slider-step {\n      //  height: 8px;\n      //}\n      //\n      //.ant-slider-handle {\n      //  width: 16px;\n      //  height: 16px;\n      //  border-color: white;\n      //  background-color: gray;\n      //  z-index: 12;\n      //}\n      //\n      //.ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {\n      //  border-color: white;\n      //}\n\n      .sliderLabel {\n        font-weight: 500;\n        font-style: normal;\n        font-size: 14px;\n      }\n\n      .upper {\n        float: left;\n        margin-left: 5px;\n        color: rgb(138, 143, 152);\n      }\n\n      .lower {\n        float: right;\n        margin-right: 5px;\n        color: rgb(138, 143, 152);\n      }\n    }\n\n  }\n}\n.sliderPopover {\n  .ant-popover-content {\n    top: 30px;\n    right: 20px;\n  }\n}\n\n\n\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
